const useStoreUpdate = (dispatch, reducer, object) => {
  const getUpdatedObject = (name, value, object) => {
    let formObject = {}
    const nameSplit = name.split('.')
    switch (nameSplit.length) {
      case 3:
        formObject = {
          ...object,
          [nameSplit[0]]: {
            ...object[nameSplit[0]],
            [nameSplit[1]]: {
              ...object[nameSplit[0]][nameSplit[1]],
              [nameSplit[2]]: value
            }
          }
        }
        break
      case 2:
        formObject = { ...object, [nameSplit[0]]: { ...object[nameSplit[0]], [nameSplit[1]]: value } }
        break
      default:
        formObject = { ...object, [name]: value }
    }

    return formObject
  }
  const updateFormObject = (e) => {
    const name = e.target.name
    const value = e.target.value
    dispatch(reducer(getUpdatedObject(name, value, object)))
  }

  const updateFormObjectProp = (prop, value) => {
    dispatch(reducer(getUpdatedObject(prop, value, object)))
  }

  return [updateFormObject, updateFormObjectProp]
}

export default useStoreUpdate